<template>
    <exclusive-offer-toast
      success
      :message="message"
      :event="event"
      :button-text="viewCartButtonText"
      :button-click-url="secondaryactionurl"
      class="added-to-cart-toast"
    />
</template>

<script>
import ExclusiveOfferToast from './ExclusiveOfferToast.vue'
import { StringService, events, RunConfigService } from '@nuskin/ns-util'
import { getConfiguration } from '@nuskin/configuration-sdk'
import { CartService } from '@nuskin/ns-shop'

export default {
  components: {
    ExclusiveOfferToast
  },
  data() {
    return {
      addedToCart: '',
      secondaryactionurl: '',
      viewYourCart: '',
      event: events.shop.ADD_TO_CART
    }
  },
  async mounted() {
    const strings = await StringService.getStrings([
      {
        key: 'viewYourCart',
        dflt: 'View Your Cart'
      }, {
        key: 'productAdded',
        dflt: 'Items added to cart'
      }
    ])

    this.addedToCart = strings.productAdded
    this.viewYourCart = strings.viewYourCart

    if ((await getConfiguration(['Equinox_Markets'])).Equinox_Markets.active) {
      const { language, country } = RunConfigService.getRunConfig()
      this.secondaryactionurl = `/${country}/${language}/viewCart`
    } else {
      this.secondaryactionurl = CartService.getCartPage()
    }
  },
  computed: {
    viewCartButtonText() {
      return (this.viewYourCart || '').replace(' ({quantity})', '')
    },
    message() {
      return this.addedToCart
    }
  }
}
</script>

<style>

</style>
